import { Colors } from '@zapier/design-system';

export const NEW_ZAP_ID = 'new-zap';

export const MOBILE_BREAKPOINT = 500;

export const MAX_WIDTH_NEW_WELCOME_PAGE_CONTENT = '1054px';

export const FALLBACK_PRIMARY_COLOR = Colors.grey300;

export const SHARE_MODAL_CLOSE_BUTTON_COLOR_THEME = {
  custom: {
    base: {
      backgroundColor: Colors.transparent,
      color: Colors.black,
    },
    disabled: {
      backgroundColor: Colors.transparent,
      color: Colors.grey400,
    },
    hover: {
      backgroundColor: Colors.transparent,
      color: Colors.grey700,
    },
    focus: {
      backgroundColor: Colors.transparent,
      outlineColor: Colors.blue500,
      color: Colors.blue500,
    },
  },
};

export const SHARE_SOCIAL_BUTTON_COLOR_THEME = {
  custom: {
    base: {
      backgroundColor: Colors.grey100,
      color: Colors.grey700,
    },
    disabled: {
      backgroundColor: Colors.grey100,
      color: Colors.grey500,
    },
    hover: {
      backgroundColor: Colors.grey000,
      color: Colors.blue500,
    },
    focus: {
      backgroundColor: Colors.grey000,
      outlineColor: Colors.blue500,
      color: Colors.blue500,
    },
  },
};

export const SHARE_LINK_COPY_BUTTON_COLOR_THEME = {
  custom: {
    base: {
      backgroundColor: Colors.transparent,
      color: Colors.black,
    },
    disabled: {
      backgroundColor: Colors.transparent,
      color: Colors.grey400,
    },
    hover: {
      backgroundColor: Colors.transparent,
      color: Colors.grey700,
    },
    focus: {
      backgroundColor: Colors.blue500,
      outlineColor: Colors.transparent,
      color: Colors.white,
    },
  },
};
